//@ts-expect-error import
import * as zoid from '@krakenjs/zoid/dist/zoid.frameworks'

export const createZoidComponent = (url: string) => {
  zoid.destroy()
  return zoid.create({
    tag: 'powtoon-producer-integration',
    dimensions: {
      width: '100%',
      height: '100%'
    },
    url,
    props: {
      onOpenWorkspace: {
        type: 'function',
        required: true
      },
      onOpenStudio: {
        type: 'function',
        required: true
      },
      onOpenPublishPage: {
        type: 'function',
        required: true
      },
      onGeneratePowtoonCompleted: {
        type: 'function',
        required: true
      },
      getUserIdOneTimeToken: {
        type: 'function',
        required: true
      },
      isUserAuthenticated: {
        type: 'boolean',
        required: true,
        default: false
      },
      canGenerateProducerPowtoon: {
        type: 'boolean',
        required: true,
        default: false
      },
      unauthMaxDailyProducerGenerations: {
        type: 'string',
        required: true,
        default: ''
      },
      userIdOneTimeToken: {
        type:  'string'
      },
      subDomain: {
        type:  'string',
        required: true,
        default: ''
      },
      trackBiEvent: {
        type: 'function',
        required: true
      },
      trackPageView: {
        type: 'function',
        required: true
      }
    },
    attributes: {
      iframe: {
        scrolling: 'no',
        allowFullScreen: 'true'
      }
    }
  })
}